import {
	CREATE_SPIN_GAME_MESSAGE_REQUEST,
	CREATE_SPIN_GAME_MESSAGE_SUCCESS,
	CREATE_SPIN_GAME_MESSAGE_FAIL,
	FETCH_SPIN_GAME_MESSAGES_REQUEST,
	FETCH_SPIN_GAME_MESSAGES_SUCCESS,
	FETCH_SPIN_GAME_MESSAGES_FAIL,
	UPDATE_SPIN_GAME_MESSAGE_REQUEST,
	UPDATE_SPIN_GAME_MESSAGE_SUCCESS,
	UPDATE_SPIN_GAME_MESSAGE_FAIL,
	DELETE_SPIN_GAME_MESSAGE_REQUEST,
	DELETE_SPIN_GAME_MESSAGE_SUCCESS,
	DELETE_SPIN_GAME_MESSAGE_FAIL,
	FETCH_SPIN_GAME_MESSAGE_REQUEST,
	FETCH_SPIN_GAME_MESSAGE_SUCCESS,
	FETCH_SPIN_GAME_MESSAGE_FAIL,
} from "../constants/spinTheWheelGameMessage";

const initState = {
	status: "IDLE",
	loading: false,
	spinGameMessageUpdated: false,
	error: null,
	spinGameMessageDeleted: false,
};

function createSpinGameMessageReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}

	switch (action.type) {
		case CREATE_SPIN_GAME_MESSAGE_REQUEST:
			return { loading: true };
		case CREATE_SPIN_GAME_MESSAGE_SUCCESS:
			return {
				loading: false,
				success: true,
				spinGameMessage: action.payload.data,
			};
		case CREATE_SPIN_GAME_MESSAGE_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function fetchSpinGameMessagesReducer(state, action) {
	if (typeof state === "undefined") {
		state = initState;
	}
	switch (action.type) {
		case FETCH_SPIN_GAME_MESSAGES_REQUEST:
			return { ...initState, loading: true };
		case FETCH_SPIN_GAME_MESSAGES_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinGameMessageDeleted: false,
				spinGameMessages: action.payload,
			};
		case FETCH_SPIN_GAME_MESSAGES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateSpinGameMessageReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null, spinGameMessageUpdated: false };
	}
	switch (action.type) {
		case UPDATE_SPIN_GAME_MESSAGE_REQUEST:
			return { loading: true };
		case UPDATE_SPIN_GAME_MESSAGE_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinGameMessageUpdated: true,
			};
		case UPDATE_SPIN_GAME_MESSAGE_FAIL:
			return {
				loading: false,
				spinGameMessageUpdated: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

function deleteSpinGameMessageReducer(state, action) {
	if (typeof state === "undefined") {
		state = initState;
	}
	switch (action.type) {
		case DELETE_SPIN_GAME_MESSAGE_REQUEST:
			return {
				...initState,
				status: "IDLE",
				loading: true,
				spinGameMessageDeleted: false,
			};
		case DELETE_SPIN_GAME_MESSAGE_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				spinGameMessageDeleted: true,
			};
		case DELETE_SPIN_GAME_MESSAGE_FAIL:
			return {
				loading: false,
				spinGameMessageDeleted: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

function fetchSpinGameMessageReducer(state, action) {
	if (typeof state === "undefined") {
		state = initState;
	}

	switch (action.type) {
		case FETCH_SPIN_GAME_MESSAGE_REQUEST:
			return { ...initState, loading: true, spinGameMessageDeleted: false };
		case FETCH_SPIN_GAME_MESSAGE_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				spinGameMessageDeleted: false,
				spinGameMessage: action.payload,
			};
		case FETCH_SPIN_GAME_MESSAGE_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export {
	createSpinGameMessageReducer,
	fetchSpinGameMessagesReducer,
	updateSpinGameMessageReducer,
	deleteSpinGameMessageReducer,
	fetchSpinGameMessageReducer,
};
